import { Typography } from '@packages/fenrir/components/typography';

export const PrintHeaderContent = ({
  organizationName,
}: {
  organizationName?: string;
}) => {
  return organizationName ? <Typography>{organizationName}</Typography> : null;
};
